'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./Thumb.scss');

var Thumb = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(Thumb, _PureComponent);

  function Thumb() {
    (0, _classCallCheck3.default)(this, Thumb);
    return (0, _possibleConstructorReturn3.default)(this, (Thumb.__proto__ || (0, _getPrototypeOf2.default)(Thumb)).apply(this, arguments));
  }

  (0, _createClass3.default)(Thumb, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          fileName = _props.fileName,
          className = _props.className,
          onClick = _props.onClick,
          urlPartName = _props.urlPartName,
          defaultImageName = _props.defaultImageName,
          size = _props.size,
          asBackground = _props.asBackground;

      var noImage = require('assets/' + (size ? defaultImageName + '-' + size : defaultImageName) + '.png'); // eslint-disable-line import/no-dynamic-require
      var thumbUrl = fileName ? _config2.default.app.urlParts[urlPartName] + fileName : noImage;

      if (asBackground) {
        return _react2.default.createElement('div', {
          style: { backgroundImage: 'url(\'' + thumbUrl + '\')' },
          className: (0, _bind2.default)(styles.bg, className),
          onClick: onClick
        });
      }

      return _react2.default.createElement('img', {
        alt: '',
        src: thumbUrl,
        className: className,
        onClick: onClick,
        draggable: false,
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        }
      });
    }
  }]);
  return Thumb;
}(_react.PureComponent), _class.propTypes = {
  asBackground: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  defaultImageName: _propTypes2.default.string,
  fileName: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  size: _propTypes2.default.string,
  urlPartName: _propTypes2.default.string
}, _class.defaultProps = {
  defaultImageName: 'no-image',
  size: '',
  urlPartName: 'thumb'
}, _temp);
exports.default = Thumb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Thumb/Thumb.js
// module id = 259
// module chunks = 1